import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzEaster65 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_65: Record<
  Exclude<PageIdWoofzEaster65, PageIdWoofzEaster65.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_EASTER_65]: {
    id: PageId.SUBSCRIPTIONS_EASTER_65,
  },
  [PageId.CHAT_UPSELL_EASTER_65]: {
    id: PageId.CHAT_UPSELL_EASTER_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EASTER_65]: {
    id: PageId.UPSELL_EASTER_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_EASTER_65]: {
    id: PageId.DOWNLOAD_EASTER_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
